import AppCSSService from "../../services/AppCSSService";
import { IDeviceStateControllerReturn } from "../../../../../commonreact/main/services/devicestate/DeviceStateController";
import CommonReactGUIElementsFactory from "../../../../../commonreact/main/factorys/guielements/CommonReactGUIElementsFactory";

import { IModalVideoControllerReturn } from "../../../../../commonreact/main/components/modals/modalvideo/ModalVideoController";
import { WebsitePromoVideoCard } from "./uimodels/cards/WebsitePromoVideoCard";
import { WebsiteVideoGalleryCard } from "./uimodels/cards/WebsiteVideoGalleryCard";

interface IProps {
  dsc: IDeviceStateControllerReturn;
  mvc: IModalVideoControllerReturn;
}

const Website = (props: IProps) => {

  const ef = CommonReactGUIElementsFactory.getFactory({})

  return (<>
    <div className={`${AppCSSService.cardsWrapper} ${(!props.dsc.small && !props.dsc.isMobile) ? "w-4/5" : "w-full"} mt-4`}>
    <WebsitePromoVideoCard dsc={props.dsc} ef={ef} />
    <WebsiteVideoGalleryCard dsc={props.dsc} ef={ef} mvc={props.mvc} />

  </div>
  </>
  )
};

export default Website;